import type { OwnerTrialView } from '@/types/backend'
import { computeTrial } from '@/lib/trial'

export function TrialBadge({ owner }: { owner: OwnerTrialView }) {
  const t = computeTrial(owner)
  if (t.state === 'NO_TRIAL' || owner.planStartedAt) return null
  if (t.state === 'ACTIVE') {
    return (
      <span className='inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-sm text-amber-800'>
        <span className='h-2 w-2 rounded-full bg-amber-500' />
        Essai — {t.daysLeft} j restants
      </span>
    )
  }
  return (
    <span className='inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-sm text-rose-800'>
      <span className='h-2 w-2 rounded-full bg-rose-500' />
      Essai expiré
    </span>
  )
}
